import React from "react";
import { AssetImageUrl } from "../../../../assets/imgUrl";
import { AccountItem, AccountList, Cart, Favorites, IconArea, LoginButton, NotLoggedIn, NotLoggedInButtons, RegisterButton, Account, Icon, ActiveIcon, IconName, WelcomeTitle, CartCount, CartList, CartEmpty, CartMoreItems, CartProductList, CartProduct, CartProductImgArea, CartProductImgLink, CartProductImg, CartProductInfoArea, CartProductInfoTitle, CartProductInfoLink, CartProductInfoAttrPrice, CartProductInfoAttr, CartProductInfoPrice, CartProductTotal, CartProductPrice, CartProductBottom, MyCart, Checkout, CheckoutArrow, HeaderLogo, HeaderButtons, CartProductInfoColor, HeaderKeyword, HeaderKeywords, HeaderKeywordSplit, HeaderPageLet, HeaderRightArea } from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import WebSearch from "./Search";
import { getTopKeywords, userLoginout } from "../../../../services/header/header";
import Constant, { delKeyFromCookie, WEB_HOST } from "../../../../utils/constant";
import langGroup from "../../../../assets/lang.json";
import getLangKeyValueFun from "../../../../utils/lang";
import { MIDDLE_QUERY, SEARCH_RESULT } from "../../utils";
const getText = getLangKeyValueFun(langGroup);
class WebHeaderPageLet extends React.Component {
    constructor(props) {
        super(props);
        this.onLogOff = () => {
            userLoginout({
                sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined
            })
                .then((res) => {
                var _a;
                if ((_a = res.info) === null || _a === void 0 ? void 0 : _a.logoff_status) {
                    delKeyFromCookie("sessionKey");
                    location.reload();
                }
            })
                .catch(err => console.error(err));
        };
        this.onMainPage = (mainPage) => {
            const { userName } = this.props;
            let query = "login";
            if (userName) {
                switch (mainPage) {
                    case "Orders":
                        query = "account";
                        break;
                    case "Favorites":
                        query = "wish_list";
                        break;
                    case "Tickets":
                        query = "ticket_center";
                        break;
                    case "Rewards":
                        query = "store_credit";
                        break;
                    case "Coupons":
                        query = "coupon_list";
                        break;
                    case "Cart":
                    case "Checkout":
                        query = "shopping_cart";
                        break;
                }
            }
            location.href = `${MIDDLE_QUERY()}${query}`;
        };
        this.onProductPage = (products_url, item_id) => {
            location.href = `${WEB_HOST[Constant.isUat ? "UAT" : "Online"].ghost}/${Constant.language}/p/${products_url}_p${item_id}.html`;
        };
        this.onSearchPage = (keyword) => {
            location.href = `${SEARCH_RESULT()}${keyword}`;
        };
        this.state = {
            topKeyWords: []
        };
    }
    componentDidMount() {
        getTopKeywords({ category_id: 0 })
            .then((res) => {
            let topKeyWords = res.info;
            this.setState({ topKeyWords: topKeyWords.slice(0, 5) });
        })
            .catch(err => {
            console.log(err);
        });
    }
    render() {
        var _a, _b;
        const { cart, userName } = this.props;
        const { topKeyWords } = this.state;
        const currencySymbol = (cart === null || cart === void 0 ? void 0 : cart.currencySymbol) || `${((_b = (_a = cart === null || cart === void 0 ? void 0 : cart.items) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.currency) || ""} `;
        return (React.createElement(HeaderPageLet, null,
            React.createElement(HeaderLogo, { href: "/" },
                React.createElement("img", { src: AssetImageUrl["pc_logo"], alt: "lightinthebox" })),
            React.createElement(HeaderRightArea, null,
                React.createElement(HeaderButtons, null,
                    React.createElement(WebSearch, null),
                    React.createElement(Account, null,
                        React.createElement(IconArea, { onClick: () => this.onMainPage() },
                            React.createElement(Icon, { src: AssetImageUrl["pc_account"] }),
                            React.createElement(ActiveIcon, { src: AssetImageUrl["pc_account_active"] }),
                            React.createElement(IconName, null, userName || getText("Sign In"))),
                        React.createElement(AccountList, null,
                            React.createElement(Triangle, { style: { left: "22%" } }),
                            React.createElement(TriangleShadow, { style: { left: "22%" } }),
                            !userName && (React.createElement(NotLoggedIn, null,
                                React.createElement(WelcomeTitle, null, getText("Welcome to LightInTheBox")),
                                React.createElement(NotLoggedInButtons, null,
                                    React.createElement(RegisterButton, { onClick: () => this.onMainPage() }, "Register"),
                                    React.createElement(LoginButton, { onClick: () => this.onMainPage() }, "Sign In")))),
                            React.createElement(AccountItem, { onClick: () => this.onMainPage("Orders") }, getText("My Orders")),
                            React.createElement(AccountItem, { onClick: () => this.onMainPage("Favorites") }, getText("My Favorites")),
                            React.createElement(AccountItem, { onClick: () => this.onMainPage("Tickets") }, getText("My Tickets")),
                            React.createElement(AccountItem, { onClick: () => this.onMainPage("Rewards") }, getText("My Rewards & Credit")),
                            React.createElement(AccountItem, { onClick: () => this.onMainPage("Coupons") }, getText("My Coupons")),
                            userName && (React.createElement(AccountItem, { onClick: this.onLogOff }, getText("Sign Out"))))),
                    React.createElement(Favorites, null,
                        React.createElement(IconArea, { onClick: () => this.onMainPage("Favorites") },
                            React.createElement(Icon, { src: AssetImageUrl["pc_like"] }),
                            React.createElement(ActiveIcon, { src: AssetImageUrl["pc_like_active"] }),
                            React.createElement(IconName, null, getText("Favorites")))),
                    React.createElement(Cart, null,
                        React.createElement(IconArea, { onClick: () => this.onMainPage("Cart") },
                            React.createElement(CartCount, null, cart.totalLen > 999 ? "999+" : cart.totalLen),
                            React.createElement(Icon, { src: AssetImageUrl["pc_cart"] }),
                            React.createElement(ActiveIcon, { src: AssetImageUrl["pc_cart_active"] }),
                            React.createElement(IconName, null, getText("Cart"))),
                        React.createElement(CartList, { className: !cart.totalLen && "isEmpty" },
                            React.createElement(Triangle, { style: { left: "91%" } }),
                            React.createElement(TriangleShadow, { style: { left: "91%" } }),
                            !cart.totalLen && (React.createElement(React.Fragment, null,
                                React.createElement(CartEmpty, null),
                                getText("Your shopping cart is empty"),
                                ".")),
                            !!cart.totalLen && (React.createElement(React.Fragment, null,
                                React.createElement(CartMoreItems, null, `${cart.totalLen} ${getText("items in shopping cart")}`),
                                React.createElement(CartProductList, null, (cart.items || []).map((item, index) => (React.createElement(CartProduct, { key: index, className: index && "split", onClick: () => this.onProductPage(item === null || item === void 0 ? void 0 : item.products_url, item === null || item === void 0 ? void 0 : item.item_id) },
                                    React.createElement(CartProductImgArea, null,
                                        React.createElement(CartProductImgLink, null,
                                            React.createElement(CartProductImg, { src: item === null || item === void 0 ? void 0 : item.thumbnail_img_url }))),
                                    React.createElement(CartProductInfoArea, null,
                                        React.createElement(CartProductInfoTitle, null,
                                            React.createElement(CartProductInfoLink, null, item === null || item === void 0 ? void 0 : item.item_name)),
                                        React.createElement(CartProductInfoAttrPrice, null,
                                            React.createElement(CartProductInfoAttr, null, ((item === null || item === void 0 ? void 0 : item.display_skus) || []).map((i, idx) => (React.createElement(React.Fragment, { key: idx },
                                                React.createElement(CartProductInfoColor, { className: idx && "split" },
                                                    i
                                                        .split("-")[0]
                                                        .trim(),
                                                    ":"),
                                                i.split("-")[1].trim())))),
                                            React.createElement(CartProductInfoPrice, null,
                                                currencySymbol, item === null || item === void 0 ? void 0 :
                                                item.total_price))))))),
                                React.createElement(CartProductTotal, null,
                                    getText("Cart Total"),
                                    ":\u00A0",
                                    React.createElement(CartProductPrice, null,
                                        currencySymbol,
                                        cart.totalPrice)),
                                React.createElement(CartProductBottom, null,
                                    React.createElement(MyCart, { onClick: () => this.onMainPage("Cart") },
                                        getText("View My Cart"),
                                        React.createElement(CheckoutArrow, { src: AssetImageUrl["pc_arrow"] })),
                                    React.createElement(Checkout, { onClick: () => this.onMainPage("Checkout") }, getText("Proceed to Checkout")))))))),
                React.createElement(HeaderKeywords, null, topKeyWords.map((item, index) => (React.createElement(React.Fragment, { key: index },
                    React.createElement(HeaderKeyword, { key: index, onClick: () => this.onSearchPage(item === null || item === void 0 ? void 0 : item.keywords) }, item === null || item === void 0 ? void 0 : item.keywords),
                    index !== topKeyWords.length - 1 && React.createElement(HeaderKeywordSplit, null))))))));
    }
}
export default WebHeaderPageLet;
